import React, { InputHTMLAttributes } from 'react';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  inputClassName?: string;
}

const Checkbox = ({ className, id, inputClassName, label, ...rest }: Props): JSX.Element => (
  <span className={`${className ?? ''} block`}>
    <input id={id} type='checkbox' className={`align-middle rounded border-solid border-gray-900 text-sapphire focus:border-sapphire focus:ring-0 focus:ring-offset-0 focus:outline-none focus:shadow-[0_1px_5px] focus:shadow-sapphire-300/100 ${inputClassName ? ` ${inputClassName}` : ''}`} {...rest} />
    { label && <label htmlFor={id} className='ml-3 mt-0.5 align-middle inline-block'>{label}</label> }
  </span>
);

export { Checkbox };
